var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 7,
    rx: 6,
    ry: 6,
    stroke: "#172239",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00002 20.9965C0.998494 20.5514 1.08775 20.1117 1.26104 19.7108C1.80484 18.4979 3.33834 17.8551 4.61082 17.564C5.52854 17.3456 6.45893 17.1997 7.39506 17.1273C9.12825 16.9576 10.8714 16.9576 12.6046 17.1273C13.5407 17.2005 14.471 17.3464 15.3889 17.564C16.6613 17.8551 18.1948 18.4373 18.7386 19.7108C19.0871 20.5281 19.0871 21.477 18.7386 22.2943C18.1948 23.5678 16.6613 24.15 15.3889 24.4289C14.4722 24.6564 13.5415 24.8064 12.6046 24.8777C11.194 25.0111 9.7767 25.0354 8.36302 24.9505C8.03674 24.9505 7.72134 24.9505 7.39506 24.8777C6.46169 24.8073 5.53453 24.6573 4.6217 24.4289C3.33834 24.15 1.81571 23.5678 1.26104 22.2943C1.08864 21.8887 0.999468 21.4453 1.00002 20.9965Z",
    stroke: "#172239",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.003d1f7d.svg";
export { ForwardRef as ReactComponent };